import type { User } from './api.js';
import { partition, type Partition } from './filtering.js';

export type PartitionedUsers = Partition<User>;

/**
 * Делит фильтр сотрудников на работающих и неактивных.
 *
 * Неактивные сохраняются, а не отбрасываются: человек мог быть активным в начале
 * периода и деактивированным к концу, его часы всё равно относятся к отчёту.
 * Они лишь вынесены из основного списка, чтобы уволенные не заглушали тех,
 * кто работает сейчас. Поиск идёт и по логину: имена бывают неотличимы.
 */
export function partitionUsers(
  users: User[],
  search: string,
  selected: string[],
): PartitionedUsers {
  return partition(users, {
    search,
    selected,
    isActive: (user) => user.active,
    id: (user) => user.userKey,
    text: (user) => [user.displayName, user.userKey],
  });
}
